import axios from "axios"; // eslint-disable-line check-axios-usage/no-direct-axios
import * as constants from "Constants";
import { authLogout } from "Store/UserInfo/Actions";
import displayGlobalMessage from "Utils/DisplayGlobalMessage";

axios.defaults.baseURL = constants.base_url; // eslint-disable-line check-axios-usage/no-direct-axios

var instance = axios.create(); // eslint-disable-line check-axios-usage/no-direct-axios
const pendingRequests = [];
const pendingThreadRequests = [];
const pendingCommentRequests = [];

const logoutTimerId = null;

function removePending(config) {
  let index = pendingRequests.findIndex((request) => request === config);
  if (index !== -1) {
    pendingRequests.splice(index, 1);
  }
  index = pendingCommentRequests.findIndex((request) => request === config);
  if (index !== -1) {
    pendingCommentRequests.splice(index, 1);
  }
  index = pendingThreadRequests.findIndex((request) => request === config);
  if (index !== -1) {
    pendingThreadRequests.splice(index, 1);
  }
}

const validateTokenWithFetch = async () => {
  try {
    const headers = instance.defaults.headers.common;
    const response = await fetch(constants.base_url + '/accounts/whoami/', {
      method: 'GET',
      headers: headers
    });

    console.log('validation', response)

    if (response.status === 403) {
      return { isValid: false };
    } else if (response.ok) {
      return { isValid: true };
    } else {
      return { isValid: false, error: 'Unexpected response status' };
    }
  } catch (error) {
    console.error('Fetch validation error:', error);
    return { isValid: false, error };
  }
};

const createAxiosInstance = (dispatch) => {
  instance.interceptors.response.use(
    (response) => {
      // Remove the request object from the array on success
      removePending(response.config);
      return response;
    }, async (error) => {
      const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

      if (!expectedError) {
        // logger.log(error.response);
        // displayGlobalMessage(`An unexpected error occurred with status code: ${error?.response?.status} ${error?.response?.message || error?.response?.statusText || ''}`, "error");
      } else if (error.response.status === 401) {
        clearTimeout(logoutTimerId);
        // logoutTimerId = setTimeout(() => {
        //   displayGlobalMessage("Session Expired. Logging out...", "error");
        //   dispatch(logout());
        // }, 500);
        const tokenValidity = await validateTokenWithFetch();
        if (!tokenValidity.isValid) {
          displayGlobalMessage("Session Expired. Logging out...", "error", true);
          dispatch(authLogout());
        }
      } else if (error.response.status >= 500) {
        // displayGlobalMessage(`Error: ${error.response.status} - ${error.response.data.message || 'An error occurred'}`, "error");
      }

      return Promise.reject(error);
    });

  instance.interceptors.request.use(
    (config) => {
      // log.log({ check_config: config })
      pendingRequests.push(config);
      let url = config.url || "";
      if (url.includes("forum/") && url.includes("api/")) {
        if (url.includes("threads/")) {
          pendingThreadRequests.push(config);
        } else if (url.includes("comments/")) {
          pendingCommentRequests.push(config);
        }
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
}

function setJwt(jwt) {
  instance.defaults.headers.common["Authorization"] = jwt;
  //log.log("instance is", instance.defaults.headers)
}

const setupAxiosInterceptors = (dispatch) => {
  createAxiosInstance(dispatch);
};

const setupAxiosDefaults = ({ baseURL, headers }) => {
  instance.defaults.baseURL = baseURL;
  instance.defaults.headers.common = headers;
  return instance;
}

const postWithoutAuth = (url, data, config = {}) => {
  // Create a new config object that explicitly removes Authorization
  const configWithoutAuth = {
    ...config,
    headers: {
      ...config.headers,
      'Authorization': undefined // This will remove the header entirely
    }
  };

  return instance.post(url, data, configWithoutAuth);
};

export { setupAxiosInterceptors, setupAxiosDefaults };

export default {
  get: instance.get,
  post: instance.post,
  postWithoutAuth: postWithoutAuth,
  put: instance.put,
  delete: instance.delete,
  request: instance.request,
  patch: instance.patch,
  setJwt,
  pendingRequests,
  pendingCommentRequests,
  pendingThreadRequests,
  instance: instance,
  defaults: instance.defaults,
  all: axios.all, // eslint-disable-line check-axios-usage/no-direct-axios
  spread: axios.spread, // eslint-disable-line check-axios-usage/no-direct-axios
};
